module.exports = __webpack_public_path__ + "media/images/user/lp/solution/card-f53b9058d0bb19697fe50f6ef8e57729.png";